var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2WineCellar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zm-11-7H48V38.41a5.24 5.24 0 012.28-4.34 1.682 1.682 0 00.72-1.39V25h4v7.68a1.681 1.681 0 00.72 1.39A5.239 5.239 0 0158 38.41V58zM40 25v7.68a1.681 1.681 0 00.72 1.39A5.239 5.239 0 0143 38.41V58H33V38.41a5.24 5.24 0 012.28-4.34 1.682 1.682 0 00.72-1.39V25h4zM28 38.41V58H18V38.41a5.24 5.24 0 012.28-4.34 1.682 1.682 0 00.72-1.39V25h4v7.68a1.681 1.681 0 00.72 1.39A5.239 5.239 0 0128 38.41z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Wine_Cellar.ef1c155a.svg";
export { SvgE2WineCellar as ReactComponent };